import React from "react"
import { Container, Row, Col } from "reactstrap"
import "./MykaV2AskCards.scss"

const MykaV2AskCards = ({ askHeading, askCards = [], ctaLabel }) => {
  return (
    <section className="myka-v2-ask">
      <Container>
        {askHeading && (
          <h2 className="myka-v2-ask__heading">{askHeading}</h2>
        )}

        <Row className="myka-v2-ask__grid">
          {askCards.map((card) => (
            <Col key={card.title} xs={12} lg={6} className="myka-v2-ask__card-col">
              <div className="myka-v2-ask__card">
                {card.icon?.sourceUrl && (
                  <div className="myka-v2-ask__icon-wrap">
                    <img
                      src={card.icon.sourceUrl}
                      alt={card.iconAlt || ""}
                      className="myka-v2-ask__icon"
                      loading="lazy"
                    />
                  </div>
                )}
                <div className="myka-v2-ask__card-text">
                  {card.title && (
                    <h3 className="myka-v2-ask__card-title">{card.title}</h3>
                  )}
                  {card.body && (
                    <div
                      className="myka-v2-ask__card-body"
                      dangerouslySetInnerHTML={{ __html: card.body }}
                    />
                  )}
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {ctaLabel && (
          <div className="myka-v2-ask__cta-wrap">
            <button type="button" className="myka-v2-ask__cta open-chat-btn">
              {ctaLabel}
            </button>
          </div>
        )}
      </Container>
    </section>
  )
}

export default MykaV2AskCards
